import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

class About extends Component {
    render() {
        return (
            <React.Fragment>
                <PageHelmet pageTitle='เกี่ยวกับเรา' />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />


                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area attacment-fixed rn-finding-us  bg_color--1 bg_image bg_image--7 " data-black-overlay="6">
                    <div className="bg-blur">
                        <div className="container bg-blur">
                            <div className="row">
                                <div className="col-12">
                                    <div className="inner">
                                        <div className="content-wrapper">
                                            <div className="content">
                                                <h4 className="">จุดกำเนิดร้านทองเยาวราช ยโสธร<br />(ซึ่งเป็นร้านทองแรกที่ใช้ชื่อเยาวราช ของ จ. ยโสธร)</h4>
                                                <p>ตั้งแต่ปี 2498 สมัยคุณย่า เป็นช่างฝีมือ ที่รับทำทองส่งให้ร้านทอง สมัยนั้น ยโสธร ยังเป็นแค่อำเภอ มีร้านทองเล็กๆอยู่ 2-3 ร้าน จนต่อมาคุณย่าได้เปิดร้านของตัวเองขึ้นแถวตลาดเก่า หลังจากนั้นคุณพ่อเรียนจบ แต่งงานก็ได้แยกตัวมาทำ ร้านทองแรกของตัวเองตรงแถวตลาดใหม่ ชื่อว่า ห้างทองสุวรรณดี ซึ่งในสมัยนั้นขายดีมาก ลูกค้าต่อแถวซื้อเหมือนแจกฟรี  ต่อมาจึงได้ขยายสาขามาเปิดร้านทองอีกร้านให้ใหญ่ขึ้น ตรงสี่แยกหัวมุมตลาดเก่าและตั้งชื่อขึ้นใหม่ โดยใช้ชื่อว่า ห้างทองเยาวราช ยโสธร (สาขาตลาดเก่า)  ซึ่งที่มาของคำว่า เยาวราช คือเราเอาทองมาจาก เยาวราช กรุงเทพ โดยตรง แล้วตอนนั้น ยโสธร ยังไม่มีใครใช้ชื่อเยาวราชเลย เราเลยเอา เยาวราช มาตั้งเป็นชื่อร้าน ซึ่งเป็นห้างทองเยาวราชแรก ของ จ. ยโสธร โดยเราต้องการการันตี ถึงผู้บริโภคว่า ทองของเราคือมาจาก เยาวราช กรุงเทพเท่านั้น ซึ่งเป็นทองมาตรฐานตาม สคบ. ทั้งคุณภาพและน้ำหนัก พอต่อมาโซนตลาดใหม่ได้มีการปรับเปลี่ยนเส้นทางการขายของในตลาดจากเดิมที่ห้างทองสุวรรณดีตั้งอยู่ เปลี่ยนเป็นแถวหน้าห้างนานาภัณฑ์ เส้นถนน วิทยะธำรงค์ ทำให้วิถีการเดินตลาดของผู้บริโภคเปลี่ยนไป ห้างทองสุวรรณดีจึงได้ย้ายมาตั้งอยู่ตรง แถวถนนวิทยะธำรงค์หน้าห้างนานาภัณฑ์แทน แล้วได้ทำการเปลี่ยนชื่อ เป็นห้างทองเยาวราช 1 สาขาตลาดใหม่ นับตั้งแต่นั้นมา</p>
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-4 col-sm-12 mb--50 text-center">
                                                        <img src="/assets/images/about/about-15.webp" alt="ห้างทองเยาวราช1 ยโสธร " />
                                                    </div>
                                                    <div className="col-lg-4 col-md-4 col-sm-12 mb--50 text-center">
                                                        <img src="/assets/images/about/about-16.webp" alt="ห้างทองเยาวราช1 ยโสธร" />
                                                    </div>
                                                    <div className="col-lg-4 col-md-4 col-sm-12 mb--50 text-center">
                                                        <img src="/assets/images/about/about-17.webp" alt="ห้างทองเยาวราช1 ยโสธร" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Finding Us Area  */}



                {/* Start About Area */}
                <div className="about-area">
                    <div className="ptb--80 bg_color--1">
                        <div className="about-wrapper">
                            <div className="container">
                                <div class="mb--30">
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                            <h1 class="main-title">กว่า 70 ปี ที่ทำธุรกิจร้านทอง</h1>
                                            <p class="tagline">"จากรุ่นแรกสู่รุ่นที่ 3 เราได้ยึดหลักการความซื่อสัตย์ สุจริต การบริการลูกค้าทุกคนด้วยความจริงใจ มีความอ่อนน้อมถ่อมตน รับฟังความคิดเห็นลูกค้า และมีการปรับปรุงและพัฒนาตนเองอยู่เสมอ"</p>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                            <p class="tagline">เราจะเน้นทองรูปพรรณและทองคำแท่งเป็นหลัก ซึ่งจุดแข็งที่ทำให้เราประสบความสำเร็จอย่างยาวนาน นอกจากการบริการดูแลลูกค้าเป็นอย่างดีแล้ว เรามุ่งเน้นลวดลายทองคำที่สวยงาม ทันสมัย ให้เข้ากับรสนิยมการบริโภคของลูกค้าซึ่งเปลี่ยนไปแต่ละกาลเวลา</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="left-column col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img src="/assets/images/about/branch-1.webp" alt="ห้างทองเยาวราช1 ยโสธร " />
                                            <img class="mt--10" src="/assets/images/about/branch-2.webp" alt="ห้างทองเยาวราช1 ยโสธร " />
                                            <img class="mt--10" src="/assets/images/about/branch-3.webp" alt="ห้างทองเยาวราช1 ยโสธร " />
                                        </div>
                                        <div class="right-column col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img className="w-100" src="/assets/images/about/about-9.webp" alt="ห้างทองเยาวราช1" />
                                            <h1 class="main-title mt--20">ปัจจุบัน ร้านทองของเรา มีทั้งหมด 3 สาขา คือ</h1>
                                            <p class="tagline">1. ห้างทองเยาวราช 1 สาขาตลาดใหม่</p>
                                            <p class="tagline">2. ห้างทองเยาวราช สาขาตลาดเก่า</p>
                                            <p class="tagline">3. ห้างทองทองแวววาว สาขาตลาดใหม่</p>
                                            <p class="tagline mt--20 text-center">" ไม่ว่าจะทำธุรกรรมใดๆกับเรา ลูกค้าจะได้รับความพึงพอใจอย่างที่สุด "</p>
                                            <img className="mt--20" src="/assets/images/logo/logo.webp" alt="ห้างทองเยาวราช1 ยโสธร" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg_color--5 ptb--40">
                                <div className="container">
                                    <div className="row row--20 align-items-center">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="about-inner inner">
                                                <div className="section-title mt--20 mb--40 mt_mobile--10">
                                                    <h1 class="main-title mt--20">เรามุ่งเน้นลวดลายทองคำที่สวยงาม</h1>
                                                    <p class="tagline">ทันสมัย ให้เข้ากับรสนิยมการบริโภคของลูกค้าซึ่งเปลี่ยนไปแต่ละกาลเวลา</p>
                                                    <p class="section-tagline">เราเป็นธุรกิจครอบครัวที่ช่วยกันบริหารงานทุกสาขาด้วยความสามัคคีเป็นน้ำหนึ่งน้ำใจเดียวกัน เรายังมีมาตรการ ดูแลพนักงานทุกสาขา เสมือนเป็นคนในครอบครัว เราจะฝึกอบรมพนักงานทุกรุ่น ให้มุ่งเน้นการบริการให้ลูกค้าประทับใจ ลูกค้าสามารถเชื่อมั่นได้ว่า ไม่ว่าจะทำธุรกรรมใดๆกับเรา ลูกค้าจะได้รับความพึงพอใจอย่างที่สุด</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <div className="thumbnail mt_mobile--20">
                                                <img className="w-100" src="/assets/images/about/about-18.webp" alt="ห้างทองเยาวราช1" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="image-highlight ptb--50">
                                <div className="container">
                                    <h4 class="mt--20 mb--80 text-center">ทองคำเนื้อดี คุณภาพมาตรฐานตาม สคบ จากเยาวราชกรุงเทพ ลวดลายสวยประณีต โดดเด่น ทันสมัย ไม่ซ้ำใคร อัปเดตลายทองใหม่ ทุกอาทิตย์ รับประกันราคาทั้งซื้อและขายที่ลูกค้าพอใจ ทั้งราคาปลีก และราคาส่ง </h4>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                                                <img className="w-100" src="/assets/images/about/about-11.webp" alt="ห้างทองเยาวราช1" />
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                                                <img className="w-100 mt--100" src="/assets/images/about/about-12.webp" alt="ห้างทองเยาวราช1" />
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                                                <img className="w-100" src="/assets/images/about/about-13.webp" alt="ห้างทองเยาวราช1" />
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                                                <img className="w-100 mt--100" src="/assets/images/about/about-14.webp" alt="ห้างทองเยาวราช1" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End About Area */}


                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />

            </React.Fragment>
        )
    }
}
export default About